<template lang="html">
  <div>
    <van-collapse v-model="activeNames">
      <van-collapse-item
        :title="title"
        :name="role"
        :value="value"
        :label="label"
      >
        <ul>
          <li class="people" v-for="(people, index) in peoples" :key="index">
            <van-button size="small" round plain icon="https://img.yzcdn.cn/vant/logo.png" type="info">{{people}}</van-button>
          </li>
        </ul>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { Collapse, CollapseItem } from 'vant'
  Vue.use(Collapse).use(CollapseItem)

  export default {
    data () {
      return {
        activeNames: [],
      }
    },
    props: {
      role: {
        validator: function (value) {
          // 这个值必须匹配下列字符串中的一个
          return ['host', 'guest'].indexOf(value) !== -1
        }
      },
      peoples: Array,
      value: String,
      label: String
    },
    computed: {
      title () {
        let title
        if (this.role == 'host') {
          title = '主播'
        } else if (this.role == 'guest') {
          title = '嘉宾'
        }
        return title
      }
    }
  }
</script>

<style lang="css" scoped>
  li.people {
    margin-right: 5px;
    display: inline;
  }
</style>
